exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\ninput[type='number'] {\n  -moz-appearance: textfield; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?{"includePaths":["/root/src/ui","/root/src/ui/node_modules"]}!./~/import-glob-loader!./app/common/search/text-search.component.sass
// module id = 1098
// module chunks = 4